import { SiteDesignGetPayload } from 'lib/types'

type ServerSettingsPdfData = { 
    genericSystemOverhead: string,
    genericMaxCamerasPerServer: string,
    genericConcurrentSmartClientStreams: string,
    genericMachineType: string,
    genericServerDiskQuantity: string,
    genericRaidOS: string,
    hasGenericArchiving: string,
    genericAddManagementServer: boolean,
    genericSupportedCameras: string,
    genericLiveDatabaseStorageConnectivity: string,
    genericLiveDatabaseRaidType: string,
    genericLiveDatabaseDiskType: string,
    genericLiveDatabaseDiskSizeMin: string,
    genericLiveDatabaseDiskSizeMax: string,
    genericArchiving: boolean,    
    genericArchivingDatabaseArchivesPerDay: string,
    genericArchivingDatabaseStorageConnectivity: string,
    genericArchivingDatabaseRaidType: string,
    genericArchivingDatabaseDiskType: string,
    genericArchivingDatabaseDiskSizeMin: string,
    genericArchivingDatabaseDiskSizeMax: string
}


export const useServerSettingsPdfData = (siteDesignData: SiteDesignGetPayload): ServerSettingsPdfData => {

    //Global data
    const formData = siteDesignData?.formData;
    const genericArchiving = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.archiving

    //Main Settings
    const genericSystemOverhead = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.mainSettings?.systemOverhead?.toString() || '';
    const genericMaxCamerasPerServer = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.mainSettings?.maxCamerasPerServer?.toString() || '';
    const genericConcurrentSmartClientStreams = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.mainSettings?.concurrentSmartClientStreams?.toString() || '';

    //Advanced Settings
    const genericMachineType: string = (() => {
        const machineTypeValue = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.machineType;
        if (machineTypeValue) {
            return formData?.machineTypes[machineTypeValue]?.toString() || '';
        }
        return '';
    })();

    const genericServerDiskQuantity: string = (() => {
        const serverDiskQuantityValue = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.serverDiskQuantity;
        if (serverDiskQuantityValue) {
            return serverDiskQuantityValue?.toString() || '';
        }
        return 'Auto select'
    })(); 

    const genericRaidOS: string = (() => {
        const raidOSValue = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.raidOS
        if (raidOSValue) {
            return 'Yes';
        }
        return 'No'
    })(); 

    const hasGenericArchiving: string = (() => {
        const archivingValue = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.archiving
        if (archivingValue) {
            return 'Yes';
        }
        return 'No'
    })(); 

    //Managment Server Settings
    const genericAddManagementServer = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings.addManagementServer;
    const genericSupportedCameras: string = (() => {
        const supportedCamerasValue = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.managementServerSettings?.supportedCameras
        if (supportedCamerasValue >= 0) {
            return formData?.supportedCameras[supportedCamerasValue]?.toString() || '';
        }
        return '';
    })();    

    //Live Database
    const genericLiveDatabaseStorageConnectivity: string = (() => {
        const storageConnectivityValue = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.liveDatabase?.storageConnectivity;
        if (storageConnectivityValue) {
            return formData?.storageConnectivities[storageConnectivityValue]?.toString() || '';
        }
        return '';
    })();
    const genericLiveDatabaseRaidType: string = (() => {
        const raidTypeValue = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.liveDatabase?.raidType;
        if (raidTypeValue) {
            return formData?.raidTypes[raidTypeValue]?.toString() || '';
        }
        return '';
    })();

    const genericLiveDatabaseDiskType: string = (() => {
        const diskTypeValue = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.liveDatabase?.diskType
        if (diskTypeValue) {
            return formData?.diskTypes[diskTypeValue]?.toString() || '';
        }
        return '';
    })();

    const genericLiveDatabaseDiskSizeMin = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.liveDatabase?.diskSizeMin?.toString() || '';
    const genericLiveDatabaseDiskSizeMax = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.liveDatabase?.diskSizeMax?.toString() || '';

    //Archiving Database
    const genericArchivingDatabaseArchivesPerDay = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.archiveFrequency?.toString() || '';
    const genericArchivingDatabaseStorageConnectivity: string = (() => {
        const storageConnectivityValue = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.archiveDatabase?.storageConnectivity;
        if (storageConnectivityValue) {
            return formData?.storageConnectivities[storageConnectivityValue]?.toString() || '';
        }
        return '';
    })();

    const genericArchivingDatabaseRaidType: string = (() => {
        const raidTypeValue = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.archiveDatabase?.raidType;
        if (raidTypeValue) {
            return formData?.raidTypes[raidTypeValue]?.toString() || '';
        }
        return '';
    })();

    const genericArchivingDatabaseDiskType: string = (() => {
        const diskTypeValue = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.archiveDatabase?.diskType
        if (diskTypeValue) {
            return formData?.diskTypes[diskTypeValue]?.toString() || '';
        }
        return '';
    })();
    
    const genericArchivingDatabaseDiskSizeMin = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.archiveDatabase?.diskSizeMin?.toString() || '';
    const genericArchivingDatabaseDiskSizeMax = siteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.advancedSettings?.archiveDatabase?.diskSizeMax?.toString() || '';


    return {
        genericSystemOverhead,
        genericMaxCamerasPerServer,
        genericConcurrentSmartClientStreams,
        genericMachineType,
        genericServerDiskQuantity,
        genericRaidOS,
        hasGenericArchiving,
        genericAddManagementServer,
        genericSupportedCameras,
        genericLiveDatabaseStorageConnectivity,
        genericLiveDatabaseRaidType,
        genericLiveDatabaseDiskType,
        genericLiveDatabaseDiskSizeMin,
        genericLiveDatabaseDiskSizeMax,
        genericArchiving,
        genericArchivingDatabaseArchivesPerDay,
        genericArchivingDatabaseStorageConnectivity,
        genericArchivingDatabaseRaidType,
        genericArchivingDatabaseDiskType,
        genericArchivingDatabaseDiskSizeMin,
        genericArchivingDatabaseDiskSizeMax
    }
}